import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { StudyBundleCourseDto } from '../../shared/types/StudyBundleCourseDto';
import { LiveClassDto } from '../../shared/types/LiveClassDto';

@Component({
  selector: 'lp2-generic-tile',
  templateUrl: './generic-tile.component.html',
  styleUrls: ['./generic-tile.component.scss']
})
export class GenericTileComponent implements OnInit {
  @Input() tile: StudyBundleCourseDto | LiveClassDto;
  @Input() isHorizontal: boolean;
  @Input() locked: boolean;
  @Input() lockedText: string;
  @Input() imgHeight: number;

  imageUrl: SafeResourceUrl;

  public isInProgress: boolean;
  public isComplete: boolean;

  constructor(private readonly sanitizer: DomSanitizer) {
    this.isHorizontal = false;
  }

  ngOnInit() {
    this.imageUrl = this.sanitizer.bypassSecurityTrustStyle(`url('${this.tile.img}')`);
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/generic-tile/generic-tile.component.ts